import { useEffect } from 'react';

export const useCollectUTMS = (): void => {
  useEffect(() => {
    const search = new URLSearchParams(location.search);

    sessionStorage.setItem('utm_source', search.get('utm_source') || '');
    sessionStorage.setItem('utm_campaign', search.get('utm_campaign') || '');
    sessionStorage.setItem('utm_medium', search.get('utm_medium') || '');
    sessionStorage.setItem('utm_content', search.get('utm_content') || '');
  }, []);
};
